import * as React from 'react';
import { Id } from '../../utils/ids.js';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import './Toggle.scss.js';

const bem = Bem.create("vai-toggle");
const _Toggle = class extends React.Component {
  constructor() {
    super(...arguments);
    this.onKeyDown = (e) => {
      _Toggle.onKeyDown(e, this.props.checked, this.onChange);
    };
    this.onChange = () => {
      if (!this.props.disabled) {
        this.props.onChange(!this.props.checked);
      }
    };
  }
  render() {
    const { checked, disabled, htmlId, tabIndex, className } = this.props;
    const id = Id.create(htmlId, ["two way toggle"]);
    const disabledStatus = disabled ? "disabled" : "enabled";
    const checkedStatus = checked ? "checked" : "unchecked";
    return /* @__PURE__ */ React.createElement("div", {
      id: id.toString(),
      "data-ta": this.props.dataTa,
      className: addClass(bem.block(), className),
      onKeyDown: this.onKeyDown
    }, /* @__PURE__ */ React.createElement("div", {
      tabIndex: disabled ? -1 : tabIndex,
      "data-action": "aria-switch",
      "aria-labelledby": id.copyWith(["label"]).toString(),
      "aria-label": this.text,
      "aria-checked": !!checked,
      onClick: this.onChange,
      "aria-readonly": disabled,
      role: "switch",
      className: bem.element("button")(checkedStatus, disabledStatus)
    }, /* @__PURE__ */ React.createElement("span", {
      className: bem.element("screenreader")(),
      "aria-live": "polite"
    }, this.text), /* @__PURE__ */ React.createElement("span", {
      className: bem.element("thump")(checkedStatus, disabledStatus)
    })), /* @__PURE__ */ React.createElement("label", {
      id: id.copyWith(["label"]).toString(),
      className: bem.element("label")(disabledStatus),
      onClick: this.onChange
    }, this.text));
  }
  get text() {
    if (this.props.checked || this.props.uncheckedText === void 0) {
      return this.props.text;
    }
    return this.props.uncheckedText;
  }
  static onKeyDown(keyEvent, prevChecked, onChange) {
    let checked;
    switch (keyEvent.keyCode) {
      case 37: {
        checked = false;
        break;
      }
      case 39: {
        checked = true;
        break;
      }
      case 32:
      case 13: {
        checked = !prevChecked;
        break;
      }
      default:
        return;
    }
    keyEvent.stopPropagation();
    keyEvent.preventDefault();
    if (checked !== Boolean(prevChecked)) {
      onChange();
    }
  }
};
let Toggle = _Toggle;
Toggle.defaultProps = {
  checked: false,
  disabled: false,
  tabIndex: 0
};
Toggle.metaProperties = ["disabled"];

export { Toggle };
